export default __webpack_public_path__ + "static/media/email-icon.95319c4c.svg";